import React from 'react';

function UserChat(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M10.2134 11.7767C8.66864 11.1185 6.89677 11.2792 5.49567 12.2045C4.09457 13.1298 3.25114 14.6963 3.25 16.3754C3.24976 16.7206 2.96975 17.0002 2.62457 17C2.2794 16.9998 1.99977 16.7198 2 16.3746C2.00143 14.2759 3.05561 12.318 4.80681 11.1615C6.55801 10.0049 8.77262 9.80407 10.7033 10.6267C11.0209 10.762 11.1686 11.1291 11.0333 11.4467C10.898 11.7642 10.5309 11.912 10.2134 11.7767Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.1875 6.0625C4.1875 3.81884 6.00634 2 8.25 2C10.4937 2 12.3125 3.81884 12.3125 6.0625C12.3125 8.30616 10.4937 10.125 8.25 10.125C6.00634 10.125 4.1875 8.30616 4.1875 6.0625ZM8.25 3.25C6.6967 3.25 5.4375 4.5092 5.4375 6.0625C5.4375 7.6158 6.6967 8.875 8.25 8.875C9.8033 8.875 11.0625 7.6158 11.0625 6.0625C11.0625 4.5092 9.8033 3.25 8.25 3.25Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M19.4926 14.4984C18.8697 13.1236 17.4972 12.2431 15.9879 12.25L15.9851 12.25H15.9826C14.505 12.25 13.1581 13.0966 12.5175 14.4281C11.8769 15.7596 12.056 17.3404 12.9782 18.4949C13.9004 19.6493 15.4026 20.1732 16.8427 19.8426C17.0027 19.8058 17.1708 19.8335 17.3106 19.9197L19.046 20.9897L18.7243 19.137C18.6918 18.9498 18.7462 18.758 18.8721 18.6158C19.8724 17.4856 20.1154 15.8732 19.4926 14.4984ZM15.9837 11C17.9852 10.9915 19.8051 12.1593 20.6312 13.9826C21.4148 15.7122 21.1652 17.7255 20.0052 19.2075L20.515 22.1431C20.5571 22.3854 20.4532 22.6298 20.2496 22.7676C20.046 22.9054 19.7805 22.9111 19.5712 22.7821L16.8644 21.1131C15.0366 21.4348 13.1686 20.736 12.0016 19.275C10.7796 17.7453 10.5423 15.6506 11.3911 13.8862C12.2399 12.1219 14.0246 11 15.9826 11V11H15.9837Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.2084 14.75C14.2084 14.4048 14.4882 14.125 14.8334 14.125H17.3334C17.6786 14.125 17.9584 14.4048 17.9584 14.75C17.9584 15.0952 17.6786 15.375 17.3334 15.375H14.8334C14.4882 15.375 14.2084 15.0952 14.2084 14.75Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.2084 17.25C14.2084 16.9048 14.4882 16.625 14.8334 16.625H17.3334C17.6786 16.625 17.9584 16.9048 17.9584 17.25C17.9584 17.5952 17.6786 17.875 17.3334 17.875H14.8334C14.4882 17.875 14.2084 17.5952 14.2084 17.25Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default UserChat;
